import { render, staticRenderFns } from "./SecondaryDetails.vue?vue&type=template&id=bab1e6d6&scoped=true&"
import script from "./SecondaryDetails.vue?vue&type=script&lang=js&"
export * from "./SecondaryDetails.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryDetails.vue?vue&type=style&index=0&id=bab1e6d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab1e6d6",
  null
  
)

export default component.exports